export default "__VITE_ASSET__311255bc__"